import React from "react";
import SidebarAdmin from "../../components/SidebarAdmin";
import TopBarAnalitik1 from "../../components/TopBarAnalitik1";
import RingkasanAnalitikAdmin from "../../components/RingkasanAnalitikAdmin";
import "../../CSS/SemuaDataPasienTK.css";

function HalamanRingkasanAnalitik() {
  return (
    <div className="profile-page-layout">
      {/* Sidebar kiri */}
      <SidebarAdmin />

      {/* Area kanan */}
      <div className="content">
        <TopBarAnalitik1 />

        {/* Konten utama */}
        <div className="ringkasan-page">
          <RingkasanAnalitikAdmin />
        </div>
      </div>
    </div>
  );
}

export default HalamanRingkasanAnalitik;
